module.exports = __webpack_public_path__ + "img/empty-notifications.2a826d26.png";